import Event from '../../core/Event';

export default class UserLogoutCompleted extends Event {
    public static type = 'UserLogoutCompleted';

    constructor() {
        super(UserLogoutCompleted.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/user/events/UserLogoutCompleted.ts